import BaseComponent from 'foundation/base-component';
import React from 'react';
import { render } from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';
import configureStore from './store/configure-store';
import DotMailerTrackerForm from './dot-mailer-tracker-form.component';

export default class DotMailerTrackerBaseComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        this.data = {};

        try {
            this.data = JSON.parse(this.getAttribute(this.refs.data, 'options'));
        } catch (error) {
            console.log(error.message);
        }

        if (!this.data) {
            console.log('No data found');
            return;
        }

        const store = configureStore();
        render(
            <ReduxProvider store={store}>
                <DotMailerTrackerForm
                    dotMailerTrackerProperties={this.data}
                ></DotMailerTrackerForm>
            </ReduxProvider>,
            this.refs.section
        );
    }
}
